import React from "react";

import Filter from "./Filter";

const Header = () => (
  <div className="flex-header">
    <h2 className="flex-header-title">Uživatelé</h2>
    <Filter />
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/users/Header.js